/**
 * 색상 변환 헬퍼.
 *
 * Aurora Atlas 그래프는 카테고리 색을 oklch hue (0-360) 로 사용. 우리 DB 의
 * `wiki_categories.color` 는 hex (#RRGGBB) 라 변환 필요.
 *
 * `hexToHue` — hex → HSL hue. 정확도 충분 (oklch 는 perceptual 이지만 hue 자체
 * 는 HSL 과 거의 동일 0-360 회전).
 */

export function hexToHue(hex: string): number {
  const m = hex.trim().match(/^#?([0-9a-fA-F]{6})$/);
  if (!m) return 280; // fallback purple
  const raw = m[1];
  if (!raw) return 280;
  const r = Number.parseInt(raw.slice(0, 2), 16) / 255;
  const g = Number.parseInt(raw.slice(2, 4), 16) / 255;
  const b = Number.parseInt(raw.slice(4, 6), 16) / 255;
  const max = Math.max(r, g, b);
  const min = Math.min(r, g, b);
  const d = max - min;
  if (d === 0) return 0;
  let h = 0;
  if (max === r) h = ((g - b) / d) % 6;
  else if (max === g) h = (b - r) / d + 2;
  else h = (r - g) / d + 4;
  h = h * 60;
  if (h < 0) h += 360;
  return Math.round(h);
}
